import Vue from 'vue'
import Router from 'vue-router'

Vue.use(Router)

/* Layout */
import Layout from '../views/layout/Layout'

/** 通用路由表 */
export const constantRouterMap = [
  {
    path: '/login',
    component: () => import('@/views/login/index'),
    hidden: true
  },
  { 
    path: '/404', 
    component: () => import('@/views/404/404'), 
    hidden: true 
  }
]

//管理员-路由表
export const asyncRouterMap = [
  {
    path: '',
    component: Layout,
    hidden: false,
    redirect: '/cardealer',
    meta: {
      title: '车商管理',
      icon: 'cardealer'
    },
    children: [
      {
        path: 'cardealer',
        name: 'cardealer',
        hidden: false,
        component: () => import('@/views/cardealers/index'),
        meta: {
          title: '车商管理',
          icon: 'cardealer'
        },
      }
    ]
  },
  {
    path: '',
    component: Layout,
    hidden: false,
    meta: {
      title: '账户余额退款',
      icon: 'deposit'
    },
    children: [
      {
        path: 'refund',
        name: 'refund',
        hidden: false,
        component: () => import('@/views/refund/list'),
        meta: {
          title: '账户余额退款',
          icon: 'deposit'
        },
      }
    ]
  },
  {
    path: '',
    component: Layout,
    hidden: false,
    meta: {
      title: '拍卖车辆管理',
      icon: 'skill'
    },
    children: [
      {
        path: 'carElist',
        name: 'carElist',
        hidden: false,
        component: () => import('@/views/carmanage/list'),
        meta: {
          title: '拍卖车辆管理',
          icon: 'skill'
        },
      },
      {
        path: 'carDetail',
        name: 'carDetail',
        hidden: true,
        component: () => import('@/views/carmanage/detail'),
        meta: {
          title: '车辆详情',
          icon: 'skill'
        },
      }
    ]
  },
  {
    path: '',
    component: Layout,
    hidden: false,
    meta: {
      title: '发票申请',
      icon: 'kpi'
    },
    children: [
      {
        path: 'invoice',
        name: 'invoice',
        hidden: false,
        component: () => import('@/views/invoice/invoice'),
        meta: {
          title: '发票申请',
          icon: 'kpi'
        },
      }
    ]
  },
  {
    path: '',
    component: Layout,
    hidden: false,
    meta: {
      title: '账户明细',
      icon: 'skill'
    },
    children: [
      {
        path: 'account',
        name: 'account',
        hidden: false,
        component: () => import('@/views/account/index'),
        meta: {
          title: '账户明细',
          icon: 'skill'
        },
      }
    ]
  },
]

export function resetRouter() {
  const newRouter = createRouter()
  router.matcher = newRouter.matcher // reset router
}

export default new Router({
  // mode: 'history', //后端支持可开
  scrollBehavior: () => ({ y: 0 }),
  routes: constantRouterMap.concat(asyncRouterMap),
})



// WEBPACK FOOTER //
// ./src/router/index.js